import { IMarketContract, IMarketContractPost } from '../../core/interfaces/market-contracts.interface';

export class GetAllMarketContractsAction {
  static readonly type = '[MarketContract] Get All';
  constructor() {}
}

export class AddMarketContractAction {
  static readonly type = '[MarketContract] Add New Market Contract';
  constructor(public payload: IMarketContractPost) {}
}

export class UpdateMarketContractAction {
  static readonly type = '[MarketContract] Update Market Contract';
  constructor(public payload: { uuid: string; data: IMarketContractPost }) {}
}

export class DeleteMarketContractAction {
  static readonly type = '[MarketContract] Delete';
  constructor(public payload: string) {}
}

export class LoadMarketContractOptionsAction {
  static readonly type = '[MarketContract] Load Options';
  constructor() {}
}

